// 由 src/views/smart-workbench/index.vue 的 methods 拆分而来，请勿在此文件之外重复定义同名方法。
// CEO 战略规划演示与图表：战略卡片、曲线报告、分组柱状图/面积图渲染等
// 方法体与原文件逐字节一致（仅调整文件归属）。
export default {
  methods: {
    // renderProfitMarginStreamCard() {
    //   const replyId = 'profit-margin-stream-' + Date.now()
    //   const section1Id = `profit-summary-${replyId}`
    //   const section3Id = `profit-conclusion-${replyId}`

    //   const summaryText =
    //     '今年毛利率为 17.1%，去年同期为 18.7%，同比下降 1.6 个百分点。' +
    //     '毛利金额同比减少约 1,312 万元，其中销量下降贡献减少约 4,264 万元，成本上升侵蚀利润约 2,624 万元，价格竞争影响约 1,468 万元。'

    //   const conclusionText =
    //     '当前毛利率水平已低于行业平均水平约 2.3 个百分点。' +
    //     '从月度趋势来看，今年各月毛利水平均低于去年同期，呈现持续下滑态势。' +
    //     '建议优先采用 PVMC 模型针对销量下滑和成本上升两个关键维度进行深度诊断，制定针对性改善方案。'

    //   const cardHtml = `
    //     <div id="profit-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

    //       <!-- 区块1：标题 + 定义 -->
    //       <div id="profit-section-0-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
    //         <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:6px;">
    //           <div style="font-size:15px;font-weight:700;color:#1f2937;">毛利率分析报告</div>
    //           <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#fef2f2;color:#dc2626;font-size:11px;font-weight:600;">毛利率预警</span>
    //         </div>
    //         <div style="font-size:11px;color:#94a3b8;">毛利率 = (销售收入 - 销售成本) / 销售收入 × 100%</div>
    //       </div>

    //       <!-- 区块2：总结（typewriter 逐字输出） -->
    //       <div id="profit-section-1-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);opacity:0;transform:translateY(8px);transition:all .28s ease;">
    //         <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
    //           <span style="font-size:11px;font-weight:600;color:#4A5FF3;">分析结论</span>
    //         </div>
    //         <div id="${section1Id}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;"></div>
    //       </div>

    //       <!-- 区块3：趋势图（先loading骨架，再渐显SVG） -->
    //       <div id="profit-section-2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
    //         <div style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
    //           <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;">毛利率近5个月趋势对比</div>
    //           <style>@keyframes cl-spin-${replyId}{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style>
    //           <div id="profit-chart-loading-${replyId}" style="display:none;height:190px;flex-direction:column;align-items:center;justify-content:center;gap:8px;background:#f8fafc;border-radius:8px;">
    //             <div style="width:24px;height:24px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:cl-spin-${replyId} 0.8s linear infinite;"></div>
    //             <span style="font-size:11px;color:#94a3b8;">正在加载图表数据...</span>
    //           </div>
    //           <div id="profit-chart-svg-${replyId}" style="display:none;">
    //             <svg width="100%" height="190" viewBox="0 0 400 190" preserveAspectRatio="none">
    //               <defs>
    //                 <linearGradient id="barGrad1_${replyId}" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#4A5FF3;stop-opacity:1"/><stop offset="100%" style="stop-color:#4A5FF3;stop-opacity:0.5"/></linearGradient>
    //                 <linearGradient id="barGrad2_${replyId}" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#FF6B6B;stop-opacity:1"/><stop offset="100%" style="stop-color:#FF6B6B;stop-opacity:0.5"/></linearGradient>
    //                 <filter id="barShadow_${replyId}"><feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#000000" flood-opacity="0.06"/></filter>
    //               </defs>
    //               <g transform="translate(40,15)">
    //                 <line x1="0" y1="0" x2="340" y2="0" stroke="#f0f2f5" stroke-width="1"/>
    //                 <line x1="0" y1="37" x2="340" y2="37" stroke="#f0f2f5" stroke-width="1"/>
    //                 <line x1="0" y1="74" x2="340" y2="74" stroke="#f0f2f5" stroke-width="1"/>
    //                 <line x1="0" y1="111" x2="340" y2="111" stroke="#f0f2f5" stroke-width="1"/>
    //                 <line x1="0" y1="148" x2="340" y2="148" stroke="#f0f2f5" stroke-width="1"/>
    //                 <rect x="15" y="68" width="45" height="75" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="85" y="81" width="45" height="62" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="155" y="54" width="45" height="89" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="225" y="60" width="45" height="83" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="295" y="40" width="45" height="103" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="15" y="110" width="45" height="31" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="85" y="119" width="45" height="22" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="155" y="106" width="45" height="35" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="225" y="115" width="45" height="26" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <rect x="295" y="89" width="45" height="52" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
    //                 <text x="37" y="61" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">20%</text>
    //                 <text x="107" y="74" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">18%</text>
    //                 <text x="177" y="47" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">22%</text>
    //                 <text x="247" y="53" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">21%</text>
    //                 <text x="317" y="33" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">24%</text>
    //                 <text x="37" y="103" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">11%</text>
    //                 <text x="107" y="112" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">9%</text>
    //                 <text x="177" y="99" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">12%</text>
    //                 <text x="247" y="108" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">10%</text>
    //                 <text x="317" y="82" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">16%</text>
    //                 <polyline points="37,68 107,81 177,54 247,60 317,40" fill="none" stroke="#4A5FF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.9"/>
    //                 <polyline points="37,110 107,119 177,106 247,115 317,89" fill="none" stroke="#FF6B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.9"/>
    //                 <circle cx="37" cy="68" r="5" fill="#ffffff" stroke="#4A5FF3" stroke-width="2"/>
    //                 <circle cx="107" cy="81" r="5" fill="#ffffff" stroke="#4A5FF3" stroke-width="2"/>
    //                 <circle cx="177" cy="54" r="5" fill="#ffffff" stroke="#4A5FF3" stroke-width="2"/>
    //                 <circle cx="247" cy="60" r="5" fill="#ffffff" stroke="#4A5FF3" stroke-width="2"/>
    //                 <circle cx="317" cy="40" r="5" fill="#ffffff" stroke="#4A5FF3" stroke-width="2"/>
    //                 <circle cx="37" cy="110" r="5" fill="#ffffff" stroke="#FF6B6B" stroke-width="2"/>
    //                 <circle cx="107" cy="119" r="5" fill="#ffffff" stroke="#FF6B6B" stroke-width="2"/>
    //                 <circle cx="177" cy="106" r="5" fill="#ffffff" stroke="#FF6B6B" stroke-width="2"/>
    //                 <circle cx="247" cy="115" r="5" fill="#ffffff" stroke="#FF6B6B" stroke-width="2"/>
    //                 <circle cx="317" cy="89" r="5" fill="#ffffff" stroke="#FF6B6B" stroke-width="2"/>
    //               </g>
    //               <g transform="translate(40,165)">
    //                 <text x="37" y="12" text-anchor="middle" font-size="10" fill="#64748b">1月</text>
    //                 <text x="107" y="12" text-anchor="middle" font-size="10" fill="#64748b">2月</text>
    //                 <text x="177" y="12" text-anchor="middle" font-size="10" fill="#64748b">3月</text>
    //                 <text x="247" y="12" text-anchor="middle" font-size="10" fill="#64748b">4月</text>
    //                 <text x="317" y="12" text-anchor="middle" font-size="10" fill="#64748b">5月</text>
    //               </g>
    //               <g transform="translate(25,15)">
    //                 <text x="5" y="12" text-anchor="end" font-size="9" fill="#94a3b8" font-weight="500">25%</text>
    //                 <text x="5" y="49" text-anchor="end" font-size="9" fill="#94a3b8">20%</text>
    //                 <text x="5" y="86" text-anchor="end" font-size="9" fill="#94a3b8">15%</text>
    //                 <text x="5" y="123" text-anchor="end" font-size="9" fill="#94a3b8">10%</text>
    //                 <text x="5" y="160" text-anchor="end" font-size="9" fill="#94a3b8">5%</text>
    //               </g>
    //             </svg>
    //           </div>
    //           <div id="profit-chart-legend-${replyId}" style="display:none;">
    //             <div style="display:flex;justify-content:flex-start;gap:32px;margin-top:4px;padding-left:10px;">
    //               <span style="display:flex;align-items:center;gap:6px;">
    //                 <span style="width:10px;height:10px;background:#4A5FF3;border-radius:3px;"></span>
    //                 <span style="color:#64748b;font-size:11px;">去年同期</span>
    //               </span>
    //               <span style="display:flex;align-items:center;gap:6px;">
    //                 <span style="width:10px;height:10px;background:#FF6B6B;border-radius:3px;"></span>
    //                 <span style="color:#64748b;font-size:11px;">今年同期</span>
    //               </span>
    //             </div>
    //           </div>
    //         </div>
    //       </div>

    //       <!-- 区块4：数据分析结论（typewriter 逐字输出） -->
    //       <div id="profit-section-3-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
    //         <div style="font-size:12px;color:#4A5FF3;font-weight:600;margin-bottom:8px;">详细分析结论</div>
    //         <div id="${section3Id}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;"></div>
    //       </div>

    //       <!-- 区块5：操作按钮 -->
    //       <div id="profit-section-4-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
    //         <div style="display:flex;align-items:center;gap:12px;padding:10px 14px;border-radius:10px;background:#f8f9fc;border:1px solid #e8ecf0;">
    //           <button type="button" onclick="if(window.startPVMCMAnalysis){window.startPVMCMAnalysis();}" style="display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;background:linear-gradient(135deg,#4A5FF3,#637afc);color:#ffffff;font-size:12px;font-weight:600;border:none;cursor:pointer;box-shadow:0 2px 8px rgba(74,95,243,0.25);">
    //             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
    //             PVMC模型分析毛利波动原因
    //           </button>
    //           <span style="font-size:11px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="window.triggerCeoFollowUp('profit-margin-followup')">追问</span>
    //         </div>
    //       </div>
    //     </div>
    //   `
    //   this.followUpRegistry = this.followUpRegistry || {}
    //   this.followUpRegistry['profit-margin-followup'] = {
    //     title: '追问每日经营简报',
    //     summary: '基于刚才每日经营简报的结论，请继续展开说明今天最需要优先处理的风险、责任人和落地动作。',
    //     prompt: '基于刚才每日经营简报的结论，请继续展开说明今天最需要优先处理的风险、责任人和落地动作。'
    //   }

    //   this.appendLocalMessage('assistant', cardHtml, true)

    //   // 串行：每个区块通过回调链式触发，前一个完全结束后再启动下一个
    //   setTimeout(() => this.revealSection(`profit-section-0-${replyId}`, ''), 160)

    //   setTimeout(() => {
    //     this.revealSection(`profit-section-1-${replyId}`, '')
    //     setTimeout(() => {
    //       this.typeWriterEffect(section1Id, summaryText, () => {
    //         // 区块2打字完毕 → 启动区块3：图表（loading → SVG）
    //         this.revealSection(`profit-section-2-${replyId}`, '')
    //         const loadingEl = this._findVisibleEl(`profit-chart-loading-${replyId}`)
    //         if (loadingEl) loadingEl.style.display = 'flex'
    //         // loading 1.2秒后切换到 SVG
    //         setTimeout(() => {
    //           const loadingE = this._findVisibleEl(`profit-chart-loading-${replyId}`)
    //           const svgE = this._findVisibleEl(`profit-chart-svg-${replyId}`)
    //           const legendE = this._findVisibleEl(`profit-chart-legend-${replyId}`)
    //           if (loadingE) loadingE.style.display = 'none'
    //           if (svgE) { svgE.style.display = 'block'; svgE.style.opacity = '0'; svgE.style.transition = 'opacity 0.5s ease'; setTimeout(() => { svgE.style.opacity = '1' }, 50) }
    //           if (legendE) { legendE.style.display = 'block'; legendE.style.opacity = '0'; legendE.style.transition = 'opacity 0.3s ease'; setTimeout(() => { legendE.style.opacity = '1' }, 200) }
    //           // 图表加载完 → 启动区块4：详细结论
    //           setTimeout(() => {
    //             this.revealSection(`profit-section-3-${replyId}`, '')
    //             setTimeout(() => {
    //               this.typeWriterEffect(section3Id, conclusionText, () => {
    //                 // 区块4打完 → 启动区块5：按钮
    //                 this.revealSection(`profit-section-4-${replyId}`, '')
    //               })
    //             }, 280)
    //           }, 300)
    //         }, 1200)
    //       })
    //     }, 280)
    //   }, 480)
    // },
    // ============ CEO 战略规划推演 demo ============
    triggerCeoStrategyPlanningDemo() {
      // 用户消息由 CosmoClawHome.handleCardClick 写入，这里不再重复
      setTimeout(() => {
        const thinkingSteps = [
          '正在读取千亿市值目标与三曲线增长模型...',
          '正在校验 2026-2030 收入、毛利与市值目标差距...',
          '正在构建五大落地路径与演进里程碑...',
          '正在形成三曲线战略结论与风险判定...'
        ]
        this.runCfoScenarioThinking({
          thinkingId: 'ceo-strategy-planning-' + Date.now(),
          title: '战略规划推演中',
          summary: '正在将千亿市值目标拆解为三曲线、五路径与里程碑。',
          steps: thinkingSteps,
          interval: 1500,
          onComplete: () => this.renderCeoStrategyPlanningReportCard()
        })
      }, 600)
    },
    // ============ 通用：报告卡外壳 ============
    _caasShell(content) {
      return `<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e5e7eb;border-radius:12px;padding:16px 18px;box-shadow:0 2px 8px rgba(15,23,42,0.04);width:100%;min-width:280px;box-sizing:border-box;color:#0f172a;font-size:13px;line-height:1.6;">${content}</div>`
    },
    // ============ 通用：战略总判断（左侧蓝条 + 浅灰底）============
    // 支持单独给标题与描述传 id 用于打字机（如 `verdictId="x-y-head", verdictId="x-y-sub"`）
    // 接受 verdictIds: { head?: 'id', sub?: 'id' }
    _caasVerdict(headText, subText, verdictIds) {
      const ids = verdictIds || {}
      const headHtml = ids.head
        ? `<div id="${ids.head}" data-ceo-strategy-text="${this._escapeAttr(
          headText
        )}" style="font-size:13px;font-weight:700;color:#0f172a;line-height:1.5;"></div>`
        : `<div style="font-size:13px;font-weight:700;color:#0f172a;line-height:1.5;">${headText}</div>`
      const subHtml = ids.sub
        ? `<div id="${ids.sub}" data-ceo-strategy-text="${this._escapeAttr(
          subText
        )}" style="font-size:11px;color:#475569;line-height:1.7;margin-top:4px;"></div>`
        : `<div style="font-size:11px;color:#475569;line-height:1.7;margin-top:4px;">${subText}</div>`
      return `
        <div style="position:relative;padding:10px 14px 10px 16px;border-radius:8px;background:#f8fafc;border-left:3px solid #2d7ff9;margin-bottom:14px;">
          ${headHtml}
          ${subHtml}
        </div>
      `
    },
    // 把字符串里可能干扰 HTML 属性的字符（"、&）转义，避免破坏 data-ceo-strategy-text 属性。
    _escapeAttr(text) {
      if (text === undefined || text === null) return ''
      return String(text).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
    },
    // ============ 通用：分块揭示 + 打字机 ============
    // 单一 section 支持多段打字机：typewriter: 'id' / { id, text } / [{ id, text }, { id, text }, ...]
    _playSectionedReveal(sections, opts) {
      const options = opts || {}
      const gap = options.gap || 1000
      const list = Array.isArray(sections) ? sections : []
      let index = 0
      const self = this
      self._ensureCeoStrategyStyles()
      const revealSection = (sec) => {
        if (!sec || !sec.el) return Promise.resolve()
        const el = self._findVisibleEl(sec.el)
        if (el) {
          el.style.display = 'block'
          void el.offsetHeight
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'
          el.dataset.revealed = '1'
        }
        return Promise.resolve()
      }
      const runTypewriter = (id, text) => {
        return new Promise(function (resolve) {
          self.typeWriterEffect(id, text, function () {
            resolve()
          })
        })
      }
      const runLoading = (sec) => {
        if (!sec || !sec.loading) return Promise.resolve()
        // 蒙版旋转模式：section 内容已在 DOM 中，显示蒙版遮罩覆盖内容，loading 完后隐藏蒙版
        if (sec.loading.kind === 'mask-spinner') {
          const secEl = sec.el ? self._findVisibleEl(sec.el) : null
          if (!secEl) return Promise.resolve()
          const mask = secEl.querySelector('.ceo-strategy-mask')
          if (!mask) return Promise.resolve()
          mask.style.display = 'flex'
          mask.innerHTML = self._renderCeoLoadingPlaceholder('mask-spinner')
          const ms = typeof sec.loading.ms === 'number' ? sec.loading.ms : 1000
          return new Promise(function (resolve) {
            setTimeout(function () {
              if (mask) mask.style.display = 'none'
              resolve()
            }, ms)
          })
        }
        // 占位替换模式：把目标元素替换为骨架/占位，loading 完后替换为实际内容
        if (!sec.loading.el) return Promise.resolve()
        const el = self._findVisibleEl(sec.loading.el)
        if (!el) return Promise.resolve()
        const ms = typeof sec.loading.ms === 'number' ? sec.loading.ms : 1000
        const placeholder =
          typeof sec.loading.placeholder === 'string'
            ? sec.loading.placeholder
            : self._renderCeoLoadingPlaceholder(sec.loading.kind || 'chart')
        el.innerHTML = placeholder
        el.dataset.revealed = '1'
        return new Promise(function (resolve) {
          setTimeout(function () {
            // 再次校验元素还在视口（防止用户收起再打开导致旧节点被替换）
            const fresh = self._findVisibleEl(sec.loading.el)
            if (fresh) {
              fresh.innerHTML = sec.loading.realContent || ''
              fresh.dataset.revealed = '1'
            }
            resolve()
          }, ms)
        })
      }
      const runAllTypewriters = (sec) => {
        let chain = Promise.resolve()
        if (sec.typewriter && sec.text) {
          chain = chain.then(function () {
            return runTypewriter(sec.typewriter, sec.text)
          })
        }
        if (sec.typewriters && Array.isArray(sec.typewriters)) {
          sec.typewriters.forEach(function (tw) {
            if (!tw || !tw.id || !tw.text) return
            chain = chain.then(function () {
              return runTypewriter(tw.id, tw.text)
            })
          })
        }
        if (sec.loading) {
          chain = chain.then(function () {
            return runLoading(sec)
          })
        }
        return chain
      }
      const step = () => {
        if (index >= list.length) return
        const sec = list[index]
        index += 1
        revealSection(sec).then(function () {
          const chain = runAllTypewriters(sec)
          if (chain) {
            chain.then(function () {
              setTimeout(step, gap)
            })
          } else {
            setTimeout(step, gap)
          }
        })
      }
      step()
    },
    // ============ 通用：隐藏 section 包装 ============
    // 用 data-revealed 属性 + CSS 规则保证面板收起再打开后，已揭示的块仍保持显示。
    // JS 揭示时会同时把 data-revealed 设为 "1"，并通过样式适配。
    _caasHiddenSection(id, content) {
      return `<div id="${id}" class="ceo-strategy-section" style="display:none;opacity:0;transform:translateY(8px);transition:opacity .3s ease,transform .3s ease;position:relative;">
        ${content}
        <div id="${id}-mask" class="ceo-strategy-mask" style="position:absolute;inset:0;display:none;align-items:center;justify-content:center;background:#fafbfc;border-radius:12px;z-index:5;flex-direction:column;gap:8px;"></div>
      </div>`
    },
    // ============ 通用：CEO 战略卡片 loading 占位 ============
    // kind: 'chart' (240px 高 + 柱状骨架) | 'metrics' (120px 高 + 4 个小卡骨架)
    _renderCeoLoadingPlaceholder(kind) {
      if (kind === 'mask-spinner') {
        return `
          <style>@keyframes ceo-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>
          <div style="width:36px;height:36px;border:3px solid #e5e7eb;border-top-color:#3b82f6;border-radius:50%;animation:ceo-spin 1s linear infinite;"></div>
          <div style="font-size:11px;color:#64748b;">加载中…</div>
        `
      }
      if (kind === 'metrics') {
        const card = `
          <div style="flex:1;padding:12px 14px;border-radius:10px;background:#ffffff;border:1px solid #e5e7eb;display:flex;flex-direction:column;align-items:flex-start;gap:6px;">
            <div style="width:60%;height:8px;border-radius:4px;background:linear-gradient(90deg,#f1f5f9 0%,#e2e8f0 50%,#f1f5f9 100%);background-size:200% 100%;animation:ceo-skeleton 1.2s linear infinite;"></div>
            <div style="width:80%;height:18px;border-radius:4px;background:linear-gradient(90deg,#f1f5f9 0%,#e2e8f0 50%,#f1f5f9 100%);background-size:200% 100%;animation:ceo-skeleton 1.2s linear infinite;"></div>
            <div style="width:40%;height:8px;border-radius:4px;background:linear-gradient(90deg,#f1f5f9 0%,#e2e8f0 50%,#f1f5f9 100%);background-size:200% 100%;animation:ceo-skeleton 1.2s linear infinite;"></div>
          </div>
        `
        return `
          <style>@keyframes ceo-skeleton{0%{background-position:200% 0}100%{background-position:-200% 0}}</style>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;padding:0;margin:0;">
            ${card}${card}${card}${card}
          </div>
          <div style="margin-top:8px;text-align:center;font-size:10px;color:#94a3b8;">加载中…</div>
        `
      }
      // chart / 默认：240px 高的柱状骨架
      return `
        <style>@keyframes ceo-skeleton{0%{background-position:200% 0}100%{background-position:-200% 0}}</style>
        <div style="padding:10px 12px;border-radius:12px;background:#ffffff;border:1px solid #e5e7eb;display:flex;flex-direction:column;gap:8px;min-height:240px;">
          <div style="display:flex;justify-content:space-between;align-items:flex-end;">
            <div style="width:40%;height:10px;border-radius:4px;background:linear-gradient(90deg,#f1f5f9 0%,#e2e8f0 50%,#f1f5f9 100%);background-size:200% 100%;animation:ceo-skeleton 1.2s linear infinite;"></div>
            <div style="width:20%;height:10px;border-radius:4px;background:linear-gradient(90deg,#f1f5f9 0%,#e2e8f0 50%,#f1f5f9 100%);background-size:200% 100%;animation:ceo-skeleton 1.2s linear infinite;"></div>
          </div>
          <div style="flex:1;display:flex;align-items:flex-end;gap:10px;padding-top:14px;">
            ${[40, 65, 50, 80, 95]
    .map(function (h, i) {
      return (
        '<div style="flex:1;height:' +
                  h +
                  '%;border-radius:6px;background:linear-gradient(90deg,#f1f5f9 0%,#e2e8f0 50%,#f1f5f9 100%);background-size:200% 100%;animation:ceo-skeleton ' +
                  (1.2 + i * 0.08) +
                  's linear infinite;"></div>'
      )
    })
    .join('')}
          </div>
          <div style="text-align:center;font-size:10px;color:#94a3b8;">图表加载中…</div>
        </div>
      `
    },
    // ============ 通用：CEO 战略卡片持久化样式 ============
    // data-revealed="1" 的 section 通过 !important 强制显示，确保对话框收起再打开后
    // 已揭示的内容不会因为 v-html 重新渲染显示属性的初始值（display:none）而消失。
    _ensureCeoStrategyStyles() {
      if (typeof document === 'undefined') return
      if (document.getElementById('ceo-strategy-section-style')) return
      const style = document.createElement('style')
      style.id = 'ceo-strategy-section-style'
      style.textContent = [
        '.ceo-strategy-section[data-revealed="1"]{',
        'display:block!important;',
        'opacity:1!important;',
        'transform:translateY(0)!important;',
        '}'
      ].join('')
      document.head.appendChild(style)
    },
    // ============ 通用：eyebrow + 标题 + 周期 ============
    _caasHero(eyebrowIcon, eyebrowText, eyebrowColor, title, period) {
      return `
        <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:4px;">
          <div style="display:inline-flex;align-items:center;gap:6px;font-size:11px;color:#64748b;">
            <span style="color:#94a3b8;">·</span><span>${eyebrowText}</span>
          </div>
          <div style="font-size:11px;color:#8c8c8c;">${period}</div>
        </div>
        <div style="font-size:14px;font-weight:700;color:#0f172a;margin-bottom:10px;">${title}</div>
      `
    },
    // ============ 通用：区块标题 + 右侧备注 ============
    _caasSectionHead(icon, iconColor, title, note) {
      return `
        <div style="display:flex;align-items:center;justify-content:space-between;margin:16px 0 8px;">
          <div style="display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:700;color:#0f172a;">
            <span>${title}</span>
          </div>
          ${note ? `<div style="font-size:10px;color:#94a3b8;">${note}</div>` : ''}
        </div>
      `
    },
    // ============ 通用：底部推荐问题芯片（事件委托版）============
    _caasFollowUp(items) {
      const buttons = items
        .map(
          (item) => `
            <button type="button" data-ceo-strategy="${item.action}" data-ceo-strategy-label="${item.label}" style="padding:6px 12px;border-radius:8px;background:#f1f5f9;border:1px solid #e2e8f0;color:#1f2937;font-size:11px;font-weight:600;cursor:pointer;transition:all .2s ease;">${item.label}</button>
          `
        )
        .join('')
      return `<div style="display:flex;flex-wrap:wrap;gap:8px;padding-top:12px;border-top:1px solid #f1f5f9;margin-top:12px;">${buttons}</div>`
    },
    async handleCeoStrategyFollowUpAction(e) {
      // 旧工作台通过 v-show 隐藏时，不处理 click 事件
      if (this.$el && !this.$el.offsetParent) return
      const target =
        e.target && e.target.closest && e.target.closest('[data-ceo-strategy]')
      if (!target) return
      const action = target.getAttribute('data-ceo-strategy')
      const label = target.getAttribute('data-ceo-strategy-label')
      if (!action) return
      // 1. 先写用户气泡（与点击的 chip 文字一致）
      if (label) {
        await this.persistMockMessage('user', label)
      }
      // 2. 再渲染对应大卡
      if (action === 'open-strategy-planning') {
        this.renderCeoStrategyPlanningReportCard()
      } else if (action === 'open-curve1') {
        this.renderCeoCurve1Report()
      } else if (action === 'open-curve2') {
        this.renderCeoCurve2Report()
      } else if (action === 'open-curve3') {
        this.renderCeoCurve3Report()
      } else if (action === 'open-chain-breakdown') {
        this.renderCeoH1SummaryCard()
      }
      // 3. 强制滚动到底部（用户可能停留在对话中部，常规 cosmo-claw-scroll-bottom
      //    在 !autoScroll 时会早退，所以走强制滚动事件）
      this.$nextTick(() => {
        this.forceScrollToBottom()
        // curve1/2/3 是 setTimeout(200ms) 内渲染，再补一次
        setTimeout(() => this.forceScrollToBottom(), 280)
      })
    },
    // ============ 通用：底部数据来源 chip ============
    _caasSources(sources) {
      const chips = sources
        .map(
          (s) => `
            <span style="display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:999px;background:#3b82f6;color:#ffffff;font-size:10px;font-weight:600;">
              <i class="fa ${s.icon}"></i><span>${s.label}</span>
            </span>
          `
        )
        .join('')
      return `<div style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;margin-top:8px;"><span style="font-size:11px;color:#64748b;margin-right:4px;">数据来源</span>${chips}</div>`
    },
    // ============ 通用：单条关键判定行（白卡 + 左侧竖色条 + 浅灰底）============
    _caasFinding(index, title, desc, color) {
      const palette = {
        blue: { bar: '#2d7ff9', bg: '#f8fafc', title: '#0f172a', desc: '#475569' },
        orange: { bar: '#f97316', bg: '#f8fafc', title: '#0f172a', desc: '#475569' },
        green: { bar: '#10b981', bg: '#f8fafc', title: '#0f172a', desc: '#475569' },
        red: { bar: '#ef4444', bg: '#f8fafc', title: '#0f172a', desc: '#475569' },
        purple: { bar: '#8b5cf6', bg: '#f8fafc', title: '#0f172a', desc: '#475569' }
      }[color] || { bar: '#2d7ff9', bg: '#f8fafc', title: '#0f172a', desc: '#475569' }
      return `
        <div style="position:relative;padding:10px 14px 10px 16px;border-radius:8px;background:${palette.bg};border-left:3px solid ${palette.bar};">
          <div style="display:flex;align-items:flex-start;gap:8px;">
            <span style="font-size:11px;color:#64748b;flex-shrink:0;font-weight:600;margin-top:1px;">${index}</span>
            <div style="flex:1;min-width:0;">
              <div style="font-size:13px;font-weight:700;color:${palette.title};">${title}</div>
              <div style="font-size:11px;color:${palette.desc};line-height:1.6;margin-top:2px;">${desc}</div>
            </div>
          </div>
        </div>
      `
    },
    // ============ 通用：单条主指标卡（统一文字对齐 + 底部绿色状态行）============
    _renderMetricCard({ value, unit, sub, status, statusColor }) {
      const statusColorFinal = statusColor || '#0aa66a'
      return `
        <div style="padding:12px 14px;border-radius:10px;background:#ffffff;border:1px solid #e5e7eb;display:flex;flex-direction:column;align-items:flex-start;gap:6px;text-align:left;">
          <div style="font-size:10px;color:#64748b;line-height:1.4;">${sub || ''}</div>
          <div style="font-size:20px;font-weight:700;color:#0f172a;line-height:1.1;">${value}<span style="font-size:11px;color:#64748b;margin-left:2px;">${
  unit || ''
}</span></div>
          ${
  status
    ? `<div style="font-size:10px;font-weight:700;color:${statusColorFinal};line-height:1.4;">${status}</div>`
    : ''
}
        </div>
      `
    },
    // ============ 通用：路径动作卡（白底 + 灰底右上角标签）============
    _renderStrategyActionCard(icon, color, title, desc, tag) {
      return `
        <div style="display:flex;align-items:flex-start;gap:10px;padding:10px 12px;border-radius:10px;background:#ffffff;border:1px solid #e5e7eb;">
          <div style="width:26px;height:26px;border-radius:6px;background:#3b82f6;color:#ffffff;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:12px;">
            <i class="fa ${icon}"></i>
          </div>
          <div style="flex:1;min-width:0;">
            <div style="display:flex;align-items:center;justify-content:space-between;gap:6px;">
              <span style="font-size:12px;font-weight:700;color:#0f172a;">${title}</span>
              <span style="padding:2px 8px;border-radius:4px;background:#f1f5f9;color:#64748b;font-size:10px;font-weight:600;flex-shrink:0;">${tag}</span>
            </div>
            <div style="font-size:11px;color:#475569;line-height:1.6;margin-top:4px;">${desc}</div>
          </div>
        </div>
      `
    },
    // ============ 通用：里程碑行（紫色虚线时间线）============
    _renderStrategyTimelineRow(title, desc) {
      return `
        <div style="position:relative;padding:6px 0 6px 12px;">
          <span style="position:absolute;left:-7px;top:14px;width:8px;height:8px;border-radius:50%;background:#4A5FF3;box-shadow:0 0 0 3px #fff;"></span>
          <div style="font-size:13px;font-weight:700;color:#0f172a;">${title}</div>
          <div style="font-size:11px;color:#5a6b7e;line-height:1.6;margin-top:2px;">${desc}</div>
        </div>
      `
    },
    // ============ 图表 1：堆叠面积 + 双轴目标虚线（千亿市值）============
    _renderCurvesStackedAreaChart() {
      const width = 460
      const height = 244
      const padL = 40
      const padR = 44
      const padT = 26
      const padB = 36
      const innerW = width - padL - padR
      const innerH = height - padT - padB
      const cats = ['2026', '2027', '2028', '2029', '2030']
      // 三条曲线数据
      const s1 = [80, 88, 97, 105, 110] // 第一曲线
      const s2 = [0, 1.8, 2.5, 20, 30] // 第二曲线
      const s3 = [0, 0, 0, 5, 10] // 第三曲线
      const target = [200, 400, 700, 800, 1000]
      // 堆叠累计值
      const stack1 = [...s1]
      const stack2 = s1.map((v, i) => v + s2[i])
      const stack3 = stack2.map((v, i) => v + s3[i])
      const areaMax = stack3[stack3.length - 1] // 150
      const marketMax = Math.max(...target) // 1000
      const leftStep = 50
      const leftMax = Math.ceil((areaMax * 1.25) / leftStep) * leftStep // 200
      const rightLowerMax = leftMax // 200
      const rightUpperMax = Math.ceil((marketMax * 1.1) / 100) * 100 // 1100→1200
      // 双轴分区：下区占 7/11，上区占 4/11
      const lowerRatio = 7 / 11
      const lowerH = innerH * lowerRatio
      const upperH = innerH - lowerH
      const baseline = padT + innerH
      const dividerY = baseline - lowerH

      const xFor = (i) => padL + (innerW / (cats.length - 1)) * i
      const yLeft = (v) => baseline - (v / leftMax) * lowerH
      const yRight = (v) => {
        if (v <= rightLowerMax) return baseline - (v / rightLowerMax) * lowerH
        return (
          dividerY - ((v - rightLowerMax) / (rightUpperMax - rightLowerMax)) * upperH
        )
      }

      // 堆叠面积多边形
      const areaPoly = (stack, prevStack) => {
        let topPts = ''
        let botPts = ''
        for (let i = 0; i < cats.length; i++) {
          topPts += xFor(i).toFixed(1) + ',' + yLeft(stack[i]).toFixed(1) + ' '
          botPts =
            xFor(i).toFixed(1) +
            ',' +
            yLeft(prevStack ? prevStack[i] : 0).toFixed(1) +
            ' ' +
            botPts
        }
        return topPts + botPts
      }
      // 面积值标签（居中在每段内）
      const areaLabels = (series, prevStack) => {
        let html = ''
        for (let i = 0; i < cats.length; i++) {
          const v = series[i]
          if (v <= 0) continue
          const midVal = prevStack ? (prevStack[i] + stackFor(series, i)) / 2 : v / 2
          const midY = yLeft(midVal)
          html += `<text x="${xFor(i).toFixed(1)}" y="${(midY + 3).toFixed(
            1
          )}" text-anchor="middle" fill="#fff" font-size="9" font-weight="700">${v}</text>`
        }
        return html
      }
      const stackFor = (s, i) => {
        // 找到 series 对应的 stack
        if (s === s1) return stack1[i]
        if (s === s2) return stack2[i]
        if (s === s3) return stack3[i]
        return 0
      }

      // 顶线
      const topLine = (stack) => {
        let pts = ''
        for (let i = 0; i < cats.length; i++) {
          pts += xFor(i).toFixed(1) + ',' + yLeft(stack[i]).toFixed(1) + ' '
        }
        return pts
      }

      // 左轴网格和标签
      const leftGrid = [0, 50, 100, 150, 200]
      const leftGridHtml = leftGrid
        .map((v) => {
          if (v === 0) {
            return `<line x1="${padL}" y1="${yLeft(v)}" x2="${width - padR}" y2="${yLeft(
              v
            )}" stroke="#e2e8f0" stroke-width="1"></line>`
          }
          return ''
        })
        .join('')
      const leftLabelHtml = leftGrid
        .map((v) => {
          return `<text x="${padL - 6}" y="${(yLeft(v) + 3).toFixed(
            1
          )}" text-anchor="end" font-size="10" fill="#94a3b8">${v}</text>`
        })
        .join('')

      // 右轴：下区与左轴共用刻度，上区 200 步长
      const rightLowerGrid = leftGrid.filter((v) => v <= rightLowerMax)
      const rightUpperGrid = []
      for (let v = rightLowerMax + 200; v <= rightUpperMax; v += 200) {
        rightUpperGrid.push(v)
      }
      const rightLowerLabelHtml = rightLowerGrid
        .map((v) => {
          return `<text x="${width - padR + 6}" y="${(yRight(v) + 3).toFixed(
            1
          )}" text-anchor="start" font-size="10" fill="#94a3b8">${v}</text>`
        })
        .join('')
      const rightUpperLabelHtml = rightUpperGrid
        .map((v) => {
          return `<text x="${width - padR + 6}" y="${(yRight(v) + 3).toFixed(
            1
          )}" text-anchor="start" font-size="10" fill="#475569" font-weight="600">${v}</text>`
        })
        .join('')
      // 右轴网格线
      const rightLowerGridLines = rightLowerGrid
        .map((v) => {
          if (v === 0 || v === rightLowerMax) return ''
          return `<line x1="${padL}" y1="${yRight(v).toFixed(1)}" x2="${
            width - padR
          }" y2="${yRight(v).toFixed(
            1
          )}" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2 3" stroke-opacity="0.6"></line>`
        })
        .join('')
      const rightUpperGridLines = rightUpperGrid
        .map((v) => {
          return `<line x1="${padL}" y1="${yRight(v).toFixed(1)}" x2="${
            width - padR
          }" y2="${yRight(v).toFixed(
            1
          )}" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2 3" stroke-opacity="0.6"></line>`
        })
        .join('')

      // 分隔线（右轴 200 位置）
      const dividerHtml = `<line x1="${padL}" y1="${dividerY.toFixed(1)}" x2="${
        width - padR
      }" y2="${dividerY.toFixed(
        1
      )}" stroke="#d97706" stroke-width="1.2" stroke-dasharray="4 3" stroke-opacity="0.55"></line>`
      const dividerBadge = `<rect x="${(width - padR - 36).toFixed(1)}" y="${(
        dividerY - 8
      ).toFixed(
        1
      )}" width="32" height="14" rx="3" fill="#fffbeb" stroke="#fde68a" stroke-opacity="0.8"></rect><text x="${(
        width -
        padR -
        20
      ).toFixed(1)}" y="${(dividerY + 2).toFixed(
        1
      )}" text-anchor="middle" font-size="9" font-weight="700" fill="#d97706">200</text>`

      // 市值目标线 + 点
      const targetPts = target
        .map((v, i) => xFor(i).toFixed(1) + ',' + yRight(v).toFixed(1))
        .join(' ')
      const targetDotsHtml = target
        .map((v, i) => {
          return `<circle cx="${xFor(i).toFixed(1)}" cy="${yRight(v).toFixed(
            1
          )}" r="4.5" fill="#94a3b8" stroke="#ffffff" stroke-width="2.5"></circle>
          <text x="${xFor(i).toFixed(1)}" y="${(yRight(v) - 10).toFixed(
  1
)}" text-anchor="middle" font-size="10" font-weight="700" fill="#475569">${v}</text>`
        })
        .join('')

      // 基线
      const baselineHtml = `<line x1="${padL}" y1="${baseline}" x2="${
        width - padR
      }" y2="${baseline}" stroke="#cbd5e1" stroke-width="1"></line>`

      // X 轴标签
      const xLabelHtml = cats
        .map((c, i) => {
          return `<text x="${xFor(i).toFixed(1)}" y="${
            height - 10
          }" text-anchor="middle" font-size="10" fill="#64748b">${c}</text>`
        })
        .join('')

      // 轴说明
      const axisLabels = `<text x="${padL}" y="15" font-size="9" fill="#94a3b8">亿(收入)</text>
        <text x="${
  width - padR
}" y="15" text-anchor="end" font-size="9" fill="#94a3b8">亿(市值)</text>`

      // 图例
      const legend = `
        <div style="display:flex;align-items:center;gap:14px;flex-wrap:wrap;font-size:10px;color:#475569;margin-bottom:8px;">
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#4a5ff3;"></span>第一曲线</span>
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#d97706;"></span>第二曲线</span>
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#059669;"></span>第三曲线</span>
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:14px;height:0;border-top:2.4px dashed #94a3b8;"></span>市值目标（右轴）</span>
        </div>
      `

      return `
        <div style="padding:10px 12px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
            <div style="font-size:12px;font-weight:700;color:#0f172a;">三曲线收入堆叠 &amp; 市值目标 2026—2030</div>
            <div style="text-align:right;">
              <div style="font-size:11px;font-weight:700;color:#1f2937;">累计 80→150 亿</div>
              <div style="font-size:10px;color:#8c8c8c;">市值 200→1000 亿（右轴）</div>
            </div>
          </div>
          ${legend}
          <svg viewBox="0 0 ${width} ${height}" width="100%" preserveAspectRatio="xMidYMid meet" style="display:block;">
            ${axisLabels}
            ${leftGridHtml}
            ${rightLowerGridLines}
            ${rightUpperGridLines}
            ${baselineHtml}
            ${dividerHtml}
            <!-- 第一曲线面积 -->
            <polygon points="${areaPoly(
    stack1,
    null
  )}" fill="#4a5ff3" opacity="0.7"></polygon>
            <!-- 第二曲线面积 -->
            <polygon points="${areaPoly(
    stack2,
    stack1
  )}" fill="#d97706" opacity="0.7"></polygon>
            <!-- 第三曲线面积 -->
            <polygon points="${areaPoly(
    stack3,
    stack2
  )}" fill="#059669" opacity="0.7"></polygon>
            <!-- 面积内数值标签 -->
            ${areaLabels(s1, null)}
            ${areaLabels(s2, stack1)}
            ${areaLabels(s3, stack2)}
            <!-- 顶线 -->
            <polyline points="${topLine(
    stack1
  )}" fill="none" stroke="#4a5ff3" stroke-width="1.8" stroke-opacity="0.95"></polyline>
            <polyline points="${topLine(
    stack2
  )}" fill="none" stroke="#d97706" stroke-width="1.8" stroke-opacity="0.95"></polyline>
            <polyline points="${topLine(
    stack3
  )}" fill="none" stroke="#059669" stroke-width="1.8" stroke-opacity="0.95"></polyline>
            <!-- 市值目标线 -->
            <polyline points="${targetPts}" fill="none" stroke="#94a3b8" stroke-width="2.4" stroke-dasharray="6 4" stroke-linecap="round"></polyline>
            ${targetDotsHtml}
            ${dividerBadge}
            ${leftLabelHtml}
            ${rightLowerLabelHtml}
            ${rightUpperLabelHtml}
            ${xLabelHtml}
          </svg>
        </div>
      `
    },
    // ============ 图表 2：分组柱状图（基础行业当前 vs 2030）============
    _renderGroupedBarChart() {
      const cats = ['家电', '汽车', '流程', '机械装备', '泛半导体']
      const a = [10, 2.7, 3.7, 4.5, 9]
      const b = [15, 4, 6, 7, 13]
      const max = 20
      const scaleStep = 5
      const scaleMax = Math.ceil((max * 1.15) / scaleStep) * scaleStep // 25
      const width = 440
      const height = 220
      const padL = 36
      const padR = 16
      const padT = 26
      const padB = 36
      const innerW = width - padL - padR
      const innerH = height - padT - padB
      const groupW = innerW / cats.length
      const barW = Math.min(16, (groupW - 2) / 2)
      const gap = 2
      const groupInnerW = barW * 2 + gap
      const yFor = (v) => padT + innerH - (innerH * v) / scaleMax
      const ticks = []
      for (let v = 0; v <= scaleMax; v += scaleStep) ticks.push(v)
      const yTicksHtml = ticks
        .map(
          (v) => `
            <line x1="${padL}" y1="${yFor(v).toFixed(1)}" x2="${width - padR}" y2="${yFor(
  v
).toFixed(1)}" stroke="#e2e8f0" stroke-width="1" />
            <text x="${padL - 7}" y="${(yFor(v) + 3).toFixed(
  1
)}" text-anchor="end" font-size="10" fill="#94a3b8">${v}</text>
          `
        )
        .join('')
      const barsHtml = cats
        .map((c, i) => {
          const gx = padL + groupW * (i + 0.5)
          const bx0 = gx - groupInnerW / 2
          const yA = yFor(a[i])
          const hA = padT + innerH - yA
          const yB = yFor(b[i])
          const hB = padT + innerH - yB
          return `
            <rect x="${bx0.toFixed(1)}" y="${yA.toFixed(1)}" width="${barW.toFixed(
  1
)}" height="${hA.toFixed(1)}" fill="#64748b" rx="3" opacity="0.92"></rect>
            <text x="${(bx0 + barW / 2).toFixed(1)}" y="${(yA - 6).toFixed(
  1
)}" text-anchor="middle" font-size="10" font-weight="600" fill="#64748b">${
  a[i]
}</text>
            <rect x="${(bx0 + barW + gap).toFixed(1)}" y="${yB.toFixed(
  1
)}" width="${barW.toFixed(1)}" height="${hB.toFixed(
  1
)}" fill="#4a5ff3" rx="3" opacity="0.92"></rect>
            <text x="${(bx0 + barW + gap + barW / 2).toFixed(1)}" y="${(yB - 6).toFixed(
  1
)}" text-anchor="middle" font-size="10" font-weight="700" fill="#4a5ff3">${
  b[i]
}</text>
            <text x="${gx.toFixed(1)}" y="${
  height - 10
}" text-anchor="middle" font-size="10" fill="#64748b">${c}</text>
          `
        })
        .join('')
      const subHeader = `
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
          <div style="font-size:12px;font-weight:700;color:#0f172a;">基础行业 当前 vs 2030 目标</div>
          <div style="text-align:right;">
            <div style="font-size:11px;font-weight:700;color:#1f2937;">5 行业合计 +50%</div>
            <div style="font-size:10px;color:#8c8c8c;">流程 +62% 弹性最大</div>
          </div>
        </div>
      `
      const legend = `
        <div style="display:flex;align-items:center;gap:14px;flex-wrap:wrap;font-size:10px;color:#475569;margin-bottom:6px;">
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#64748b;"></span>当前收入</span>
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#4a5ff3;"></span>2030 目标</span>
          <span style="margin-left:auto;color:#8c8c8c;">亿元</span>
        </div>
      `
      return `
        <div style="padding:10px 12px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          ${subHeader}
          ${legend}
          <svg viewBox="0 0 ${width} ${height}" width="100%" preserveAspectRatio="xMidYMid meet" style="display:block;">
            <text x="${padL}" y="13" font-size="9" fill="#94a3b8">亿元</text>
            ${yTicksHtml}
            ${barsHtml}
          </svg>
        </div>
      `
    },
    // ============ 图表 3：分组柱状图（AI 收费模式）============
    _renderAiBillingBarChart() {
      const cats = ['嵌入原产品', '按用量计费', '订阅', '按结果收益']
      const ai = [14, 24, 20, 16]
      const saas = [35, 21, 20, 10]
      const max = 35 // SaaS max
      const scaleStep = 10
      const scaleMax = Math.ceil((max * 1.15) / scaleStep) * scaleStep // 40
      const width = 440
      const height = 220
      const padL = 36
      const padR = 16
      const padT = 26
      const padB = 36
      const innerW = width - padL - padR
      const innerH = height - padT - padB
      const groupW = innerW / cats.length
      const barW = Math.min(16, (groupW - 2) / 2)
      const gap = 2
      const groupInnerW = barW * 2 + gap
      const yFor = (v) => padT + innerH - (innerH * v) / scaleMax
      const ticks = []
      for (let v = 0; v <= scaleMax; v += scaleStep) ticks.push(v)
      const yTicksHtml = ticks
        .map(
          (v) => `
            <line x1="${padL}" y1="${yFor(v).toFixed(1)}" x2="${width - padR}" y2="${yFor(
  v
).toFixed(1)}" stroke="#e2e8f0" stroke-width="1" />
            <text x="${padL - 7}" y="${(yFor(v) + 3).toFixed(
  1
)}" text-anchor="end" font-size="10" fill="#94a3b8">${v}</text>
          `
        )
        .join('')
      const barsHtml = cats
        .map((c, i) => {
          const gx = padL + groupW * (i + 0.5)
          const bx0 = gx - groupInnerW / 2
          const yA = yFor(ai[i])
          const hA = padT + innerH - yA
          const yB = yFor(saas[i])
          const hB = padT + innerH - yB
          return `
            <rect x="${bx0.toFixed(1)}" y="${yA.toFixed(1)}" width="${barW.toFixed(
  1
)}" height="${hA.toFixed(1)}" fill="#d97706" rx="3" opacity="0.92"></rect>
            <text x="${(bx0 + barW / 2).toFixed(1)}" y="${(yA - 6).toFixed(
  1
)}" text-anchor="middle" font-size="10" font-weight="700" fill="#d97706">${
  ai[i]
}</text>
            <rect x="${(bx0 + barW + gap).toFixed(1)}" y="${yB.toFixed(
  1
)}" width="${barW.toFixed(1)}" height="${hB.toFixed(
  1
)}" fill="#64748b" rx="3" opacity="0.92"></rect>
            <text x="${(bx0 + barW + gap + barW / 2).toFixed(1)}" y="${(yB - 6).toFixed(
  1
)}" text-anchor="middle" font-size="10" font-weight="600" fill="#64748b">${
  saas[i]
}</text>
            <text x="${gx.toFixed(1)}" y="${
  height - 10
}" text-anchor="middle" font-size="10" fill="#64748b">${c}</text>
          `
        })
        .join('')
      const subHeader = `
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
          <div style="font-size:12px;font-weight:700;color:#0f172a;">中国企业级 AI 收费模式 · 2025</div>
          <div style="text-align:right;">
            <div style="font-size:11px;font-weight:700;color:#1f2937;">AI 原生更激进</div>
            <div style="font-size:10px;color:#8c8c8c;">按用量 24% / 按结果 16%</div>
          </div>
        </div>
      `
      const legend = `
        <div style="display:flex;align-items:center;gap:14px;flex-wrap:wrap;font-size:10px;color:#475569;margin-bottom:6px;">
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#d97706;"></span>AI 原生厂商</span>
          <span style="display:inline-flex;align-items:center;gap:4px;"><span style="width:8px;height:8px;border-radius:2px;background:#64748b;"></span>SaaS 厂商</span>
          <span style="margin-left:auto;color:#8c8c8c;">%</span>
        </div>
      `
      return `
        <div style="padding:10px 12px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          ${subHeader}
          ${legend}
          <svg viewBox="0 0 ${width} ${height}" width="100%" preserveAspectRatio="xMidYMid meet" style="display:block;">
            <text x="${padL}" y="13" font-size="9" fill="#94a3b8">%</text>
            ${yTicksHtml}
            ${barsHtml}
          </svg>
        </div>
      `
    },
    // ============ 1. 千亿市值战略总览卡 ============
    renderCeoStrategyPlanningReportCard(staticMsgId) {
      const uid = 'strategy-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
      const idHead = `${uid}-verdict-head`
      const idSub = `${uid}-verdict-sub`
      const secId = (i) => `${uid}-sec-${i}`

      const verdictHead =
        '三曲线累计 150 亿支撑千亿市值，PS≈6.7×，依赖 AI 估值溢价与资本运作。'
      const verdictSub =
        '沿「行业解决方案 → 工业AI产品 → 工业AI大脑」三曲线阶梯递进，2026—2030 收入从 80 亿增长至 150 亿（+87.5%）；落地成败系于 2027—2028 第二曲线能否从 2.5 亿跃升至 20 亿。'

      const hero = this._caasHero(
        'fa-road',
        'Strategy · 2026—2030',
        '#2d7ff9',
        '卡奥斯根据卡奥斯的经营情况，分析卡奥斯千亿市值目标未来的发展规划和落地路径',
        '2026—2030 · 五年'
      )
      const verdict = this._caasVerdict(verdictHead, verdictSub, {
        head: idHead,
        sub: idSub
      })

      const structure = `
        ${this._caasSectionHead(
    'fa-line-chart',
    '#2d7ff9',
    '三曲线增长结构',
    '2030 收入 / 毛利率 / 战略定位'
  )}
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
          ${this._renderMetricCard({
    value: '110',
    unit: '亿',
    sub: '第一曲线 · 行业解决方案',
    status: '毛利 39%',
    statusColor: '#d98213'
  })}
          ${this._renderMetricCard({
    value: '30',
    unit: '亿',
    sub: '第二曲线 · 工业AI产品',
    status: '毛利 60%',
    statusColor: '#0aa66a'
  })}
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
          ${this._renderMetricCard({
    value: '10',
    unit: '亿',
    sub: '第三曲线 · 工业AI大脑',
    status: '毛利 90%',
    statusColor: '#0aa66a'
  })}
          ${this._renderMetricCard({
    value: '150',
    unit: '亿',
    sub: '2030 三曲线累计',
    status: '较 2026 +87.5% · PS ≈ 6.7×',
    statusColor: '#0aa66a'
  })}
        </div>
      `
      const chartId = `${uid}-chart`
      const chart = `
        ${this._caasSectionHead(
    'fa-area-chart',
    '#2d7ff9',
    '三曲线增长趋势',
    '亿元 · 2026—2030'
  )}
        <div id="${chartId}">${this._renderCurvesStackedAreaChart()}</div>
      `
      const actions = `
        ${this._caasSectionHead(
    'fa-sitemap',
    '#2d7ff9',
    '五大落地路径',
    '目标拆解 → 产品矩阵 → 资本运作 → 生态验证'
  )}
        <div style="display:flex;flex-direction:column;gap:8px;">
          ${this._renderStrategyActionCard(
    'fa-bullseye',
    '#2d7ff9',
    '路径 1 · 目标拆解到行业',
    '千亿目标按 5 大基础行业 + 新行业 + 海外区域拆解，以行业目标为战略中枢,目标不拆到行业就落不了地。',
    '战略中枢'
  )}
          ${this._renderStrategyActionCard(
    'fa-industry',
    '#0aa66a',
    '路径 2 · 第一曲线落地',
    '做深 5 大基础行业（家电/汽车/流程/机械/泛半导体）、拓展新行业（电力装备/船舶）、开发海外市场,资源投入 + AI+FDE 全流程交付保障。',
    '规模基本盘'
  )}
          ${this._renderStrategyActionCard(
    'fa-pie-chart',
    '#d98213',
    '路径 3 · 资本运作加速',
    '并购预算 12—20 亿,补齐垂直模型与端侧 AI 硬件两大短板;投资漏斗跟踪 8 家标的（南京天洑/北京珂阳等）。',
    '补能力短板'
  )}
          ${this._renderStrategyActionCard(
    'fa-cogs',
    '#7c3aed',
    '路径 4 · 产品矩阵成熟',
    '第二曲线 5 产品（iMOM/Sphere/iEMS/机器视觉/智控器），2027 立项交付 → 2028 放量,能碳管理首推标品。',
    '出利润'
  )}
          ${this._renderStrategyActionCard(
    'fa-globe',
    '#ec4899',
    '路径 5 · 生态平台验证',
    '第三曲线从能源节能切入验证 RaaS 模式（token/按效果付费），2029 世界模型显现,2030 挑战 10 亿。',
    '撑估值'
  )}
        </div>
      `
      const timeline = `
        ${this._caasSectionHead('fa-calendar', '#2d7ff9', '演进里程碑')}
        <div style="display:flex;flex-direction:column;gap:0;position:relative;padding-left:14px;border-left:2px dashed #c7d2fe;">
          ${this._renderStrategyTimelineRow(
    '2026 · 第一曲线起步',
    '行业方案做大规模,三曲线累计 80 亿。'
  )}
          ${this._renderStrategyTimelineRow(
    '2027 · 战略聚焦落地',
    'COSMO 产品矩阵按季推进,Q1/Q2 集中立项与交付。'
  )}
          ${this._renderStrategyTimelineRow(
    '2028 · 第二曲线放量',
    '软硬一体方案规模化,从 2.5 亿跃升至 20 亿。'
  )}
          ${this._renderStrategyTimelineRow(
    '2029 · 第三曲线探索',
    '世界模型商业模式验证,挑战 5 亿收入。'
  )}
          ${this._renderStrategyTimelineRow(
    '2030 · 千亿市值达成',
    '三曲线累计 150 亿,PS≈6.7× 支撑千亿市值。'
  )}
        </div>
      `
      const findings = `
        ${this._caasSectionHead('fa-search', '#2d7ff9', '风险与关键判定')}
        <div style="display:flex;flex-direction:column;gap:8px;">
          ${this._caasFinding(
    '01',
    '落地成败系于 2027—2028',
    '第二曲线能否从 2.5 亿跃升至 20 亿,决定整个规划能否突破百亿台阶,是核心验证窗口。',
    'red'
  )}
          ${this._caasFinding(
    '02',
    '千亿市值需 PS≈6.7× 支撑',
    '150 亿收入对应千亿市值,需依赖 AI 估值溢价、生态溢价与资本运作共同支撑,非单纯经营指标。',
    'orange'
  )}
        </div>
      `
      const followUp = `
        ${this._caasSources([
    {
      icon: 'fa-database',
      label: '战略规划知识库',
      bg: '#eff6ff',
      color: '#1d4ed8'
    },
    {
      icon: 'fa-rocket',
      label: '指标定义智能体目标体系',
      bg: '#fff7ed',
      color: '#9a3412'
    }
  ])}
        <div style="font-size:13px;font-weight:700;color:#0f172a;margin-top:8px;margin-bottom:6px;">推荐问题</div>
        ${this._caasFollowUp([
    { label: '分析第一曲线落地路径', action: 'open-curve1' },
    { label: '分析第二曲线工业AI产品', action: 'open-curve2' },
    { label: '规划第三曲线商业模式', action: 'open-curve3' }
  ])}
      `

      const content = `
        ${this._caasHiddenSection(secId(0), hero)}
        ${this._caasHiddenSection(secId(1), verdict)}
        ${this._caasHiddenSection(secId(2), structure)}
        ${this._caasHiddenSection(secId(3), chart)}
        ${this._caasHiddenSection(secId(4), actions)}
        ${this._caasHiddenSection(secId(5), timeline)}
        ${this._caasHiddenSection(secId(6), findings)}
        ${this._caasHiddenSection(secId(7), followUp)}
      `
      const self = this
      const restoredPromise = this._persistCeoStrategyCard(
        this._caasShell(content),
        staticMsgId,
        '[mock:ceo-strategy-planning]',
        Array.from({ length: 8 }, (_, i) => secId(i)),
        [
          { id: idHead, text: verdictHead },
          { id: idSub, text: verdictSub }
        ]
      )
      return restoredPromise.then(function(restored) {
        if (restored) return
        self.$nextTick(function () {
          self._playSectionedReveal(
            [
              { el: secId(0) },
              {
                el: secId(1),
                typewriters: [
                  { id: idHead, text: verdictHead },
                  { id: idSub, text: verdictSub }
                ]
              },
              { el: secId(2), loading: { kind: 'mask-spinner', ms: 1000 }},
              { el: secId(3), loading: { kind: 'mask-spinner', ms: 1000 }},
              { el: secId(4) },
              { el: secId(5) },
              { el: secId(6) },
              { el: secId(7) }
            ],
            { gap: 1200 }
          )
        })
      })
    },
    // ============ 2. 第一曲线 落地路径卡 ============
    renderCeoCurve1Report(staticMsgId) {
      const execLogic = () => {
        const tableRows = [
          [
            '家电行业',
            '10',
            '<b>15</b>',
            '<span style="color:#0aa66a;font-weight:700;">+50%</span>'
          ],
          [
            '汽车行业',
            '2.7',
            '<b>4</b>',
            '<span style="color:#0aa66a;font-weight:700;">+48%</span>'
          ],
          [
            '流程行业',
            '3.7',
            '<b>6</b>',
            '<span style="color:#0aa66a;font-weight:700;">+62%</span>'
          ],
          [
            '机械装备',
            '4.5',
            '<b>7</b>',
            '<span style="color:#0aa66a;font-weight:700;">+56%</span>'
          ],
          [
            '泛半导体',
            '9',
            '<b>13</b>',
            '<span style="color:#0aa66a;font-weight:700;">+44%</span>'
          ]
        ]
        const head = `
          <thead>
            <tr style="background:#f8fafc;">
              <th style="padding:10px 12px;text-align:left;color:#475569;font-weight:600;font-size:11px;border-bottom:1px solid #e2e8f0;">基础行业</th>
              <th style="padding:10px 12px;text-align:right;color:#475569;font-weight:600;font-size:11px;border-bottom:1px solid #e2e8f0;">当前收入</th>
              <th style="padding:10px 12px;text-align:right;color:#475569;font-weight:600;font-size:11px;border-bottom:1px solid #e2e8f0;">2030 目标</th>
              <th style="padding:10px 12px;text-align:right;color:#475569;font-weight:600;font-size:11px;border-bottom:1px solid #e2e8f0;">增幅</th>
            </tr>
          </thead>
        `
        const bodyRows = tableRows
          .map(
            ([name, cur, tgt, growth]) => `
            <tr>
              <td style="padding:10px 12px;font-size:12px;color:#1f2937;border-bottom:1px solid #f1f5f9;">${name}</td>
              <td style="padding:10px 12px;font-size:12px;color:#1f2937;text-align:right;border-bottom:1px solid #f1f5f9;">${cur}</td>
              <td style="padding:10px 12px;font-size:12px;color:#1f2937;text-align:right;border-bottom:1px solid #f1f5f9;">${tgt}</td>
              <td style="padding:10px 12px;font-size:12px;text-align:right;border-bottom:1px solid #f1f5f9;">${growth}</td>
            </tr>`
          )
          .join('')
        const totalRow = `
            <tr>
              <td style="padding:10px 12px;font-size:12px;color:#0f172a;font-weight:700;background:#f8fafc;">合计</td>
              <td style="padding:10px 12px;font-size:12px;color:#0f172a;font-weight:700;text-align:right;background:#f8fafc;">29.9</td>
              <td style="padding:10px 12px;font-size:12px;color:#0f172a;font-weight:700;text-align:right;background:#f8fafc;">45</td>
              <td style="padding:10px 12px;font-size:12px;font-weight:700;text-align:right;background:#f8fafc;"><span style="color:#0aa66a;">+50%</span></td>
            </tr>`

        const uid = 'curve1-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
        const idHead = `${uid}-verdict-head`
        const idSub = `${uid}-verdict-sub`
        const secId = (i) => `${uid}-sec-${i}`

        const verdictHead =
          '做深 5 大基础行业 + 拓展新行业 + 开发海外市场,资源投入 + AI+FDE 全流程交付保障。'
        const verdictSub =
          '基础 5 大行业 2030 合计 45 亿（家电/泛半导体为规模基本盘,流程/机械增幅最积极）;新行业（电力装备/船舶）与海外为增量,目标为估算值待对齐。'

        const hero = this._caasHero(
          'fa-industry',
          '第一曲线 · 落地路径',
          '#2d7ff9',
          '行业解决方案落地路径',
          '2030 · 110 亿'
        )
        const verdict = this._caasVerdict(verdictHead, verdictSub, {
          head: idHead,
          sub: idSub
        })

        const actions = `
          ${this._caasSectionHead(
    'fa-sitemap',
    '#2d7ff9',
    '三条动作方向',
    '业务范围 -> 动作目标'
  )}
          <div style="display:flex;flex-direction:column;gap:8px;">
            ${this._renderStrategyActionCard(
    'fa-industry',
    '#2d7ff9',
    '做深 5 大基础行业',
    '家电 / 汽车汽配 / 化工 / 机械 / 泛半导体,样板复制,做到行业第一份额。',
    '规模基本盘'
  )}
            ${this._renderStrategyActionCard(
    'fa-pie-chart',
    '#d98213',
    '推进新行业拓展',
    '电力装备 / 船舶制造,标杆客户突破 + 并购优质标的。',
    '增量弹性'
  )}
            ${this._renderStrategyActionCard(
    'fa-globe',
    '#7c3aed',
    '开发海外市场',
    '跟随出海 + 海外能力体系,建立海外市场与服务体系。',
    '第二增长极'
  )}
            ${this._renderStrategyActionCard(
    'fa-cogs',
    '#0aa66a',
    '推进策略',
    '团队 ≈490 人,费用 11.6->20.7 亿,并购 12-20 亿;AI+FDE 全流程交付能力。',
    '保障双轮'
  )}
          </div>
        `
        const table = `
          ${this._caasSectionHead(
    'fa-table',
    '#2d7ff9',
    '基础行业目标分解',
    '当前 vs 2030 · 亿元'
  )}
          <div style="border-radius:10px;overflow:hidden;border:1px solid #e5e7eb;">
            <table style="width:100%;border-collapse:collapse;">${head}<tbody>${bodyRows}${totalRow}</tbody></table>
          </div>
        `
        const chartId = `${uid}-chart`
        const chart = `
          ${this._caasSectionHead(
    'fa-bar-chart',
    '#2d7ff9',
    '基础行业 当前 vs 2030 目标',
    '亿元'
  )}
          <div id="${chartId}">${this._renderGroupedBarChart()}</div>
        `
        const market = `
          ${this._caasSectionHead(
    'fa-globe',
    '#2d7ff9',
    '新行业与区域市场目标',
    '2030 · 估算值'
  )}
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
            ${this._renderMetricCard({ value: '3', unit: '亿', sub: '电力装备' })}
            ${this._renderMetricCard({ value: '2', unit: '亿', sub: '船舶制造' })}
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px;">
            ${this._renderMetricCard({ value: '95', unit: '亿', sub: '国内市场' })}
            ${this._renderMetricCard({ value: '15', unit: '亿', sub: '海外市场' })}
          </div>
          <div style="display:flex;align-items:flex-start;gap:8px;padding:10px 12px;border-radius:10px;background:#fff7ed;border:1px solid #fed7aa;font-size:11px;color:#9a3412;line-height:1.6;">
            <i class="fa fa-info-circle" style="margin-top:2px;"></i>
            <span>基础 5 大行业 2030 合计 45 亿,与第一曲线 110 亿口径存在缺口(差值含新行业、海外及其它解决方案),建议明确"基础/新行业/海外/其它"四类口径,避免目标无法加总。</span>
          </div>
        `
        const findings = `
          ${this._caasSectionHead('fa-search', '#2d7ff9', '关键判定')}
          <div style="display:flex;flex-direction:column;gap:8px;">
            ${this._caasFinding(
    '01',
    '家电、泛半导体是规模基本盘',
    '2030 合计 28 亿,占基础行业 62%,是第一曲线收入的压舱石。',
    'blue'
  )}
            ${this._caasFinding(
    '02',
    '流程行业 +62% 弹性最大',
    '基础行业普遍按「近翻倍」节奏规划,流程与机械增幅最积极,激进但需匹配资源投入。',
    'orange'
  )}
          </div>
        `
        const followUp = `
          <div style="font-size:13px;font-weight:700;color:#0f172a;margin-top:8px;margin-bottom:6px;">推荐问题</div>
          ${this._caasFollowUp([
    { label: '分析第二曲线工业AI产品', action: 'open-curve2' },
    { label: '规划第三曲线商业模式', action: 'open-curve3' },
    { label: '回看千亿市值战略总览', action: 'open-strategy-planning' }
  ])}
        `

        const content = `
          ${this._caasHiddenSection(secId(0), hero)}
          ${this._caasHiddenSection(secId(1), verdict)}
          ${this._caasHiddenSection(secId(2), actions)}
          ${this._caasHiddenSection(secId(3), table)}
          ${this._caasHiddenSection(secId(4), chart)}
          ${this._caasHiddenSection(secId(5), market)}
          ${this._caasHiddenSection(secId(6), findings)}
          ${this._caasHiddenSection(secId(7), followUp)}
        `
        const self = this
        const restoredPromise = this._persistCeoStrategyCard(
          this._caasShell(content),
          staticMsgId,
          '[mock:ceo-curve1]',
          Array.from({ length: 8 }, (_, i) => secId(i)),
          [
            { id: idHead, text: verdictHead },
            { id: idSub, text: verdictSub }
          ]
        )
        restoredPromise.then(function(restored) {
          if (restored) return
          self.$nextTick(function () {
            self._playSectionedReveal(
              [
                { el: secId(0) },
                {
                  el: secId(1),
                  typewriters: [
                    { id: idHead, text: verdictHead },
                    { id: idSub, text: verdictSub }
                  ]
                },
                { el: secId(2) },
                { el: secId(3) },
                { el: secId(4), loading: { kind: 'mask-spinner', ms: 1000 }},
                { el: secId(5) },
                { el: secId(6) },
                { el: secId(7) }
              ],
              { gap: 1200 }
            )
          })
        })
        return restoredPromise
      }
      if (staticMsgId) {
        return execLogic()
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          execLogic().then(resolve)
        }, 800)
      })
    },
    // ============ 3. 第二曲线 工业 AI 产品卡 ============
    renderCeoCurve2Report(staticMsgId) {
      const execLogic = () => {
        const productCard = (eyebrow, title, sub, bg, border, titleColor) => `
          <div style="padding:10px 12px;border-radius:8px;background:${bg};border:1px solid ${border};">
            <div style="font-size:10px;color:#64748b;margin-bottom:3px;">${eyebrow}</div>
            <div style="font-size:13px;font-weight:700;color:#0f172a;line-height:1.3;margin-bottom:4px;">${title}</div>
            <div style="font-size:10px;color:${titleColor};line-height:1.6;">${sub}</div>
          </div>
        `

        const uid = 'curve2-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
        const idHead = `${uid}-verdict-head`
        const idSub = `${uid}-verdict-sub`
        const secId = (i) => `${uid}-sec-${i}`

        const verdictHead =
          'iMOM + Sphere 双核心,能碳管理（iEMS）首推标品,2027 立项交付 -> 2028 放量。'
        const verdictSub =
          '差异化锚点各异:iMOM 走 AI 重构工业软件、对标 SAP/Siemens;Sphere 走海尔制造实践+数据治理;iEMS 走软硬一体+价值可衡量(用电↓10%、碳核算↑70%)。'

        const hero = this._caasHero(
          'fa-cogs',
          '第二曲线 · 工业AI产品',
          '#d98213',
          '工业 AI 产品落地矩阵',
          '2030 · 30 亿 · 毛利 60%'
        )
        const verdict = this._caasVerdict(verdictHead, verdictSub, {
          head: idHead,
          sub: idSub
        })

        const products = `
          ${this._caasSectionHead(
    'fa-sitemap',
    '#d98213',
    '五大产品落地矩阵',
    '竞品 / 差异化 / 渠道 / 资源'
  )}
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
            ${productCard(
    'COSMO-iMOM · 孪生制造一体化',
    'AI 重构工业软件',
    '对标 SAP/Siemens,走国产替代;AI 原生工业软件、产品标准化、多智能体协同。',
    '#ffffff',
    '#e5e7eb',
    '#475569'
  )}
            ${productCard(
    'COSMO-Sphere · 工业互联网平台',
    '海尔制造实践 + 数据治理',
    '对标蓝卓/华为/帆软;产品向 AI 智能化、转标品订阅、引 AI 人才 FDE(8+)。',
    '#ffffff',
    '#e5e7eb',
    '#475569'
  )}
            ${productCard(
    'COSMO-iEMS · 能碳管理',
    'AI 原生 + 软硬一体',
    '对标章鱼能源 Kraken;用电↓10%、碳核算↑70%,深耕大客户立标杆。',
    '#ffffff',
    '#e5e7eb',
    '#475569'
  )}
            ${productCard(
    '机器视觉 · 表面检测',
    'AI 深度学习质检',
    '对标基恩士/康耐视/海康;与 iMOM/Sphere 捆绑,深耕 3C/汽车/半导体大客户。',
    '#ffffff',
    '#e5e7eb',
    '#475569'
  )}
          </div>
          <div>
            ${productCard(
    'AI 边缘智控器',
    '工业 AI 模型端侧部署',
    '对标西门子 S7 Edge/研华/华为 Atlas;软硬一体打包,随 iEMS 能碳方案推广。',
    '#ffffff',
    '#e5e7eb',
    '#475569'
  )}
          </div>
        `
        const metrics = `
          ${this._caasSectionHead(
    'fa-table',
    '#d98213',
    '能碳管理（iEMS）价值指标',
    'COSMO ECO 一体机'
  )}
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
            ${this._renderMetricCard({
    value: '10',
    unit: '%',
    sub: '用电成本下降',
    status: 'AI 原生 · 软硬一体',
    statusColor: '#0aa66a'
  })}
            ${this._renderMetricCard({
    value: '70',
    unit: '%',
    sub: '碳核算效率提升',
    status: '价值可衡量 · 对标 Kraken',
    statusColor: '#0aa66a'
  })}
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
            ${this._renderMetricCard({
    value: 'AI 原生',
    unit: '',
    sub: '商业模式',
    status: '软硬一体 · 价值可衡量',
    statusColor: '#0aa66a'
  })}
            ${this._renderMetricCard({
    value: '最短',
    unit: '',
    sub: '客户决策周期',
    status: '首推标品 · 立标杆',
    statusColor: '#0aa66a'
  })}
          </div>
        `
        const findings = `
          ${this._caasSectionHead('fa-search', '#d98213', '关键判定')}
          <div style="display:flex;flex-direction:column;gap:8px;">
            ${this._caasFinding(
    '01',
    'iMOM + Sphere 为双核心',
    '孪生制造(执行层)+ 工业互联网平台(数据底座)构成第二曲线地基,缺一不可。',
    'blue'
  )}
            ${this._caasFinding(
    '02',
    '能碳管理是首推标品',
    '价值可量化(用电↓10%、碳核算↑70%)、对标章鱼能源 Kraken,客户决策周期最短。',
    'orange'
  )}
            ${this._caasFinding(
    '03',
    '两短板产品待设计',
    '机器视觉/智控器四维内容留白,需独立商业模式定位,当前偏配套角色。',
    'purple'
  )}
          </div>
        `
        const followUp = `
          <div style="font-size:13px;font-weight:700;color:#0f172a;margin-top:8px;margin-bottom:6px;">推荐问题</div>
          ${this._caasFollowUp([
    { label: '规划第三曲线商业模式', action: 'open-curve3' },
    { label: '回看千亿市值战略总览', action: 'open-strategy-planning' },
    { label: '回看第一曲线落地路径', action: 'open-curve1' }
  ])}
        `

        const content = `
          ${this._caasHiddenSection(secId(0), hero)}
          ${this._caasHiddenSection(secId(1), verdict)}
          ${this._caasHiddenSection(secId(2), products)}
          ${this._caasHiddenSection(secId(3), metrics)}
          ${this._caasHiddenSection(secId(4), findings)}
          ${this._caasHiddenSection(secId(5), followUp)}
        `
        const self = this
        const restoredPromise = this._persistCeoStrategyCard(
          this._caasShell(content),
          staticMsgId,
          '[mock:ceo-curve2]',
          Array.from({ length: 6 }, (_, i) => secId(i)),
          [
            { id: idHead, text: verdictHead },
            { id: idSub, text: verdictSub }
          ]
        )
        restoredPromise.then(function(restored) {
          if (restored) return
          self.$nextTick(function () {
            self._playSectionedReveal(
              [
                { el: secId(0) },
                {
                  el: secId(1),
                  typewriters: [
                    { id: idHead, text: verdictHead },
                    { id: idSub, text: verdictSub }
                  ]
                },
                { el: secId(2), loading: { kind: 'mask-spinner', ms: 1000 }},
                { el: secId(3), loading: { kind: 'mask-spinner', ms: 1000 }},
                { el: secId(4) },
                { el: secId(5) }
              ],
              { gap: 1200 }
            )
          })
        })
        return restoredPromise
      }
      if (staticMsgId) {
        return execLogic()
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          execLogic().then(resolve)
        }, 800)
      })
    },
    // ============ 4. 第三曲线 工业 AI 大脑卡 ============
    renderCeoCurve3Report(staticMsgId) {
      const execLogic = () => {
        const uid = 'curve3-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
        const idHead = `${uid}-verdict-head`
        const idSub = `${uid}-verdict-sub`
        const secId = (i) => `${uid}-sec-${i}`

        const verdictHead =
          'ToC -> ToB -> RaaS 三阶段演进,从能源节能切入验证 RaaS 模式。'
        const verdictSub =
          '第三曲线挑战 10 亿、保障度 10%;token/年费/分成模式;2029 世界模型显现,2030 挑战 10 亿,是估值溢价核心但 2030 前贡献有限,更像 2030 后的增长储备。'

        const hero = this._caasHero(
          'fa-globe',
          '第三曲线 · 商业模式演进',
          '#0aa66a',
          '工业 AI 大脑商业模式演进',
          '2030 · 10 亿 · 毛利 90%'
        )
        const verdict = this._caasVerdict(verdictHead, verdictSub, {
          head: idHead,
          sub: idSub
        })

        const timeline = `
          ${this._caasSectionHead('fa-calendar', '#2d7ff9', '三阶段商业模式演进')}
          <div style="display:flex;flex-direction:column;gap:0;position:relative;padding-left:14px;border-left:2px dashed #c7d2fe;">
            ${this._renderStrategyTimelineRow(
    'ToC · 当前免费为主',
    'C 端 43% 当前免费,29% 会员订阅,16% 按需付费,12% 一次性;靠规模做用户基础。'
  )}
            ${this._renderStrategyTimelineRow(
    'ToB · 订阅为主',
    'B 端 50% 会员订阅,30% 按需付费,13% 一次性,7% 当前免费;靠价值做企业客户。'
  )}
            ${this._renderStrategyTimelineRow(
    'RaaS · 按结果付费',
    'token/年费/分成模式,从能源节能切入验证;2029 世界模型显现,2030 挑战 10 亿。'
  )}
          </div>
        `
        const chartId = `${uid}-chart`
        const chart = `
          ${this._caasSectionHead(
    'fa-bar-chart',
    '#0aa66a',
    '中国企业级 AI 收费模式对比',
    'AI 原生 vs SaaS · 2025'
  )}
          <div id="${chartId}">${this._renderAiBillingBarChart()}</div>
        `
        const energy = `
          ${this._caasSectionHead(
    'fa-bolt',
    '#0aa66a',
    '能源切入逻辑',
    '为什么选能碳验证 RaaS'
  )}
          <div style="display:flex;flex-direction:column;gap:8px;">
            ${this._renderStrategyActionCard(
    'fa-leaf',
    '#0aa66a',
    'EMC 模式成熟',
    '合同能源管理已有成熟付费机制,效益可量化,客户接受度高。',
    '模式成熟'
  )}
            ${this._renderStrategyActionCard(
    'fa-bolt',
    '#d98213',
    '效益可量化',
    '用电↓10%、碳核算↑70%,效果直接可衡量,适配 RaaS 按结果付费。',
    '效果可衡量'
  )}
            ${this._renderStrategyActionCard(
    'fa-cogs',
    '#7c3aed',
    '算力 + 物理AI人才',
    '需算力基础设施与物理 AI 人才储备,建议产学研协同。',
    '能力保障'
  )}
          </div>
        `
        const findings = `
          ${this._caasSectionHead('fa-search', '#0aa66a', '关键判定')}
          <div style="display:flex;flex-direction:column;gap:8px;">
            ${this._caasFinding(
    '01',
    '第三曲线是估值核心',
    '毛利率 90% 接近顶级 SaaS 水平,10 亿收入贡献约 9 亿毛利,是 AI 估值溢价核心。',
    'green'
  )}
            ${this._caasFinding(
    '02',
    '2029 才起步,2030+ 储备',
    '第三曲线 29 年才显现(5亿)、30 年 10 亿,对 2030 前目标贡献有限,更像 2030 后增长储备。',
    'orange'
  )}
            ${this._caasFinding(
    '03',
    '90% 毛利为前瞻假设',
    '工业世界模型商业化尚无成熟案例,需设定阶段性验证节点。',
    'blue'
  )}
          </div>
        `
        const followUp = `
          <div style="font-size:13px;font-weight:700;color:#0f172a;margin-top:8px;margin-bottom:6px;">推荐问题</div>
          ${this._caasFollowUp([
    { label: '查看卡奥斯上半年收入业绩解构', action: 'open-chain-breakdown' },
    { label: '回看千亿市值战略总览', action: 'open-strategy-planning' },
    { label: '回看第二曲线工业AI产品', action: 'open-curve2' }
  ])}
        `

        const content = `
          ${this._caasHiddenSection(secId(0), hero)}
          ${this._caasHiddenSection(secId(1), verdict)}
          ${this._caasHiddenSection(secId(2), timeline)}
          ${this._caasHiddenSection(secId(3), chart)}
          ${this._caasHiddenSection(secId(4), energy)}
          ${this._caasHiddenSection(secId(5), findings)}
          ${this._caasHiddenSection(secId(6), followUp)}
        `
        const self = this
        const restoredPromise = this._persistCeoStrategyCard(
          this._caasShell(content),
          staticMsgId,
          '[mock:ceo-curve3]',
          Array.from({ length: 7 }, (_, i) => secId(i)),
          [
            { id: idHead, text: verdictHead },
            { id: idSub, text: verdictSub }
          ]
        )
        restoredPromise.then(function(restored) {
          if (restored) return
          self.$nextTick(function () {
            self._playSectionedReveal(
              [
                { el: secId(0) },
                {
                  el: secId(1),
                  typewriters: [
                    { id: idHead, text: verdictHead },
                    { id: idSub, text: verdictSub }
                  ]
                },
                { el: secId(2) },
                { el: secId(3), loading: { kind: 'mask-spinner', ms: 1000 }},
                { el: secId(4) },
                { el: secId(5) },
                { el: secId(6) }
              ],
              { gap: 1200 }
            )
          })
        })
        return restoredPromise
      }
      if (staticMsgId) {
        return execLogic()
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          execLogic().then(resolve)
        }, 800)
      })
    }
  }
}
